// extracted by mini-css-extract-plugin
module.exports = {"alignItemsCenter":"GiftButton_alignItemsCenter__iFL0s"};